import eventNames from './eventNames'
import { getTasksForEvent } from './tasksForEvents'

const executeTasksForEvent = (eventName: string, message: any) =>{
    const listOfTasks = getTasksForEvent(eventName);
    let messageObj = undefined;
    if(listOfTasks && listOfTasks.length > 0 && message){
        messageObj = JSON.parse(message);
    }
    for (const task of listOfTasks) {
        try {
            task(messageObj);
        } catch (error) {
            console.error(error);
        }
    }
}

const refreshWardsHandler = (message: any) => {
    executeTasksForEvent(eventNames.refreshWards, message);
}

const refreshCustomersHandler = (message: any) => {
    executeTasksForEvent(eventNames.refreshCustomers, message);
}

const refreshLocationsHandler = (message: any) => {
    executeTasksForEvent(eventNames.refreshLocations, message);
}

const refreshUsersHandler = (message: any) => {
    executeTasksForEvent(eventNames.refreshUsers, message);
}

const newTransferHandler = (message: any) =>{
    executeTasksForEvent(eventNames.newTransfer, message);
}

const transferUpdatedHandler = (message: any) =>{
    executeTasksForEvent(eventNames.transferUpdated, message);
}

const transferScheduleUpdated = (message: any) =>{
    executeTasksForEvent(eventNames.transferScheduleUpdated, message);
}

const logoutUserActiveSessions = (message: any) =>{
    executeTasksForEvent(eventNames.logoutUserActiveSessions, message);
}

const calloutUpdateHandler = (message: any) =>{
    executeTasksForEvent(eventNames.refreshCallouts, message);
}
const refreshTeammemberHandler = (message: any) => {
    executeTasksForEvent(eventNames.newTeammember, message);
}

export {
    refreshWardsHandler,
    refreshCustomersHandler,
    refreshLocationsHandler,
    refreshUsersHandler,
    newTransferHandler,
    transferUpdatedHandler,
    transferScheduleUpdated,
    logoutUserActiveSessions,
    calloutUpdateHandler,
    refreshTeammemberHandler
}